import { useContext } from 'react'

import context from '../../context/StepsProvider/context'
import { StepsProviderType } from '../../context/StepsProvider/interface'

const useSteps = (): StepsProviderType => {
  const steps = useContext(context) as StepsProviderType
  return steps
}

export default useSteps
